import React, { memo } from "react";
import { useInView } from "react-intersection-observer";
import { GalleryImage } from "./GalleryModal.styles";

const GalleryItem = ({ url, isAdded, onToggle }) => {
  const { ref, inView } = useInView({
    threshold: 0.01,
    rootMargin: "400px",
    triggerOnce: true,
  });

  const transparentPlaceholder =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAusB9YwFzNgAAAAASUVORK5CYII=";

  return (
    <GalleryImage
      ref={ref}
      $isAdded={isAdded}
      onClick={onToggle}
      src={inView ? url : transparentPlaceholder}
      alt={url}
    />
  );
};

export default memo(GalleryItem);
